import Icon, { Icons } from '@/presentation/components/elements/Icon';
import { useTranslations } from 'use-intl';

interface Props {
  hasFilters: boolean;
  canFilter: boolean;
  showFilters: boolean;
  onClick: () => void;
}

export const FilterToggle = ({
  hasFilters,
  canFilter,
  showFilters,
  onClick,
}: Props) => {
  const t = useTranslations('Swap');

  if (!canFilter) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      className={`${
        !!hasFilters
          ? 'border-pink-500 text-gray-400 bg-gray-50'
          : showFilters
          ? 'border-gray-400 bg-gray-50 text-gray-400'
          : 'bg-gray-100 border-gray-300 text-gray-400 hover:bg-gray-50'
      } rounded-full font-medium border text-sm px-3 py-2 inline-flex items-center transition-colors`}
    >
      <Icon name={Icons.FUNNEL} size={16} className="mr-2" />
      {t('Search.filters')}
      {!!hasFilters && (
        <span className="bg-pink-500 h-2 w-2 rounded-full ml-2" />
      )}
    </button>
  );
};

export default FilterToggle;
